export const PencilIcon = (props: React.HTMLAttributes<SVGElement>) => {
  const { className, ...rest } = props;

  return (
    <svg
      width='187'
      height='176'
      viewBox='0 0 187 176'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      {...rest}
    >
      <path
        d='M182.169 150.792V25.2917C182.169 13.5679 172.976 4.375 161.253 4.375C149.529 4.375 140.336 13.5679 140.336 25.2917V150.792L161.253 171.708L182.169 150.792Z'
        stroke='#EA5158'
        strokeWidth='8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M140.336 46.2083H182.169'
        stroke='#EA5158'
        strokeWidth='8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M161.25 171.708H25.2917C19.7442 171.708 14.424 169.505 10.5013 165.582C6.57871 161.659 4.375 156.339 4.375 150.792C4.375 145.244 6.57871 139.924 10.5013 136.001C14.424 132.079 19.7442 129.875 25.2917 129.875H67.125C72.6724 129.875 77.9927 127.671 81.9153 123.749C85.8379 119.826 88.0417 114.506 88.0417 108.958C88.0417 103.411 85.8379 98.0907 81.9153 94.168C77.9927 90.2454 72.6724 88.0417 67.125 88.0417H35.75'
        stroke='#8340A0'
        strokeWidth='8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
